import type { ReactNode } from "react";
import { ApiError } from "../api/errors";
import { Banner, RefId } from "./ui";

/**
 * A refused or failed write: its plain-language message, any figure the
 * screen pulls out of the typed rejection's `detail` (G-22), and the
 * idempotency key as a reference ID (UX-DESIGN.md §6). A network failure
 * says a retry is safe, because every write reuses its key (G-21).
 */
export function CommandError({ error, children }: { error: unknown; children?: ReactNode }) {
  const api = error instanceof ApiError ? error : null;
  const message = error instanceof Error ? error.message : "Something went wrong.";
  return (
    <Banner tone={api?.kind === "step_up_required" ? "neutral" : "error"} live="alert">
      <div className="stack-sm">
        <span>{message}</span>
        {children}
        {api?.retryable ? (
          <span className="small">
            We can't tell whether this reached the server. Trying again is safe: it's sent as the same request, so it can't happen twice.
          </span>
        ) : null}
        {api?.idempotencyKey ? <RefId value={api.idempotencyKey} /> : null}
      </div>
    </Banner>
  );
}
